export const LOCKED_SECTION_TOOLTIP = 'Недоступно на вашем тарифе';

export const normalizeCanViewReports = (value) => Boolean(value);
export const normalizeCanViewInference = (value) => Boolean(value);
export const normalizeCanViewCdp = (value) => Boolean(value);
export const normalizeIsAdmin = (value) => Boolean(value);

export const shouldShowReportsSection = (canViewReports) => Boolean(canViewReports);
export const shouldShowInferenceSection = (canViewInference) => Boolean(canViewInference);
export const shouldShowCdpSection = (canViewCdp) => Boolean(canViewCdp);
export const shouldShowAdminSection = (isAdmin) => Boolean(isAdmin);

export const resolveInferenceAccess = ({ canViewInference, isAdmin }) => {
  if (isAdmin || canViewInference) return 'visible';
  return 'locked';
};

export const resolveCdpAccess = ({ canViewCdp, isAdmin }) => {
  if (isAdmin || canViewCdp) return 'visible';
  return 'locked';
};

export const canAccessRoute = (route, permissions = {}) => {
  const {
    canViewReports = false,
    canViewInference = false,
    canViewCdp = false,
    isAdmin = false,
  } = permissions;

  if (isAdmin) {
    return true;
  }

  if (route?.requiresReportsAccess && !Boolean(canViewReports)) {
    return false;
  }

  if (route?.requiresInferenceAccess && !Boolean(canViewInference)) {
    return false;
  }

  if (route?.requiresCdpAccess && !Boolean(canViewCdp)) {
    return false;
  }

  if (route?.requiresAdminAccess && !Boolean(isAdmin)) {
    return false;
  }

  return true;
};
